import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, OnInit, viewChild } from '@angular/core';

import { AbstractLayerDetailComponent } from '@connect-services/client/components/project-settings/abstract-layer-detail.component';
import {
    EditLayerTemplateComponent,
    WIDTH_PX_BREAKPOINT,
} from '@connect-services/client/components/project-settings/edit-layer-template/edit-layer-template.component';
import { SlideToggleFormControlComponent } from '@connect-services/client/components/slide-toggle/slide-toggle-form-control.component';
import { UpdateLayerDto } from '@connect-services/client/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';
import { FormService } from '@shared/client/services/form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EditLayerTemplateComponent, LoadingComponent, RessourcesModule, SlideToggleFormControlComponent],
    selector: 'app-edit-flux-layer',
    styleUrl: '../edit-deposit-layer/edit-deposit-layer.component.scss',
    templateUrl: './edit-flux-layer.component.html',
})
export class EditFluxLayerComponent extends AbstractLayerDetailComponent implements OnInit {
    protected readonly formDiv = viewChild.required<ElementRef<HTMLInputElement>>('formDiv');
    protected readonly formService = inject(FormService);
    protected readonly isWide = computed(
        () =>
            this.detailPanelService.expandedVertically() &&
            this.formDiv().nativeElement.offsetWidth > WIDTH_PX_BREAKPOINT,
    );

    public override getUpdateLayerDto(): UpdateLayerDto {
        return {
            isVisible: this.formGroup()!.value.isVisible,
            name: this.formGroup()!.value.name,
            order: this.formGroup()!.value.order,
        };
    }

    public async ngOnInit(): Promise<void> {
        await this.setDataAttributes();
        this.formGroup.set(this.initFormGroup());
    }
}
